export const INDICATOR_GROUPS = [
  {
    groupName: "Pelvis",
    indicators: ["Pelvis Turn", "Pelvis Sway", "Pelvis Side Bend"],
  },
  {
    groupName: "Chest",
    indicators: ["Chest Turn", "Chest Sway", "Chest Side Bend"],
  },
  { groupName: "Composite", indicators: ["X-Factor"] },
];

export const INDICATORS = [
  "Pelvis Turn",
  "Pelvis Sway",
  "Pelvis Side Bend",
  "Chest Turn",
  "Chest Sway",
  "Chest Side Bend",
  "X-Factor",
];
